import { useGetProjectQuery } from '@verantos-dev/data-access-projects';
import { type ObjectResponse } from '@verantos-dev/types-common';
import { type ProjectDetail } from '@verantos-dev/types-projects';

export const useProjectData = (projectId: string | undefined) => {
  const { data: projectData, isLoading: isProjectLoading } = useGetProjectQuery(projectId || '', {
    skip: !projectId,
  });

  return {
    projectData: projectData as ObjectResponse<ProjectDetail> | undefined,
    isProjectLoading,
  };
};
